import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Motion";

export const ArticleCard = ({ a, i = 0 }) => (
  <Reveal delay={i * 0.08}>
    <Link to={`/insights/${a.slug}`} className="group block" data-testid={`article-card-${a.slug}`}>
      <div className="relative aspect-[4/3] overflow-hidden rounded-2xl bg-[#E5E1D3]">
        <img src={a.image} alt="" loading="lazy" className="h-full w-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-105" />
        <span className="eyebrow absolute left-4 top-4 rounded-full bg-[#F9F8F3] px-3 py-1.5 !text-[0.6rem] text-[#082619]">{a.category}</span>
      </div>
      <div className="mt-5 flex items-start justify-between gap-4">
        <h3 className="font-display text-xl md:text-2xl font-medium leading-snug text-[#082619]">{a.title}</h3>
        <ArrowUpRight className="mt-1 h-5 w-5 shrink-0 text-[#082619] transition-transform duration-500 group-hover:rotate-45" />
      </div>
      <p className="mt-3 text-sm leading-relaxed text-[#4C6053]">{a.excerpt}</p>
      <p className="eyebrow mt-4 !text-[0.6rem] text-[#4C6053]">{a.read}</p>
    </Link>
  </Reveal>
);
